import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Spin } from 'antd';
import ReconcilerAddEdit from './recon_add_edit';
import ErrorWrapper from '../../../lib/error_wrapper';

class ReconcilerEdit extends Component {
    constructor(props) {
      super(props)
    
      this.group_id=props.match.params.group_id;

      this.recon_id=props.match.params.recon_id

      this.state = {
         loaded:false,
         recon_data:{},
         edit_id:this.recon_id,
         error:false
      };

      this.detail_recon=RESTExecutor.detail().config({
          label:'reconciler_rules_detail',
          params:{
            group_id:this.group_id,
            recon_id:this.recon_id
          }
      }).callbacks((success)=>{
        this.setState({
            recon_data:success.result,
            loaded:true
        })

      },(error)=>{
        this.setState({
          loaded:true
        })
      }).connect(props.domains.settings);

      this.detail_recon.execute()
    };
    
  render() {
      const  {loaded}=this.state;
      if(!loaded){
          return <center><Spin /></center>
      }
      else{
        let detail_resp=this.detail_recon.response();
        return (
        <ErrorWrapper
        error={detail_resp}
        onReload={()=>{
          this.setState({
            loaded:false
          });
          this.detail_recon.execute()
        }}>
        <ReconcilerAddEdit 
        {...this.props}
        key={`- ${this.state.edit_id}`}
        form_data={this.state.recon_data}
        edit_id={this.state.edit_id}
        />
        </ErrorWrapper>
        )
      }
    
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.match.params.recon_id !== prevProps.match.params.recon_id||this.props.match.params.group_id !== prevProps.match.params.group_id) {
        this.recon_id = this.props.match.params.recon_id;
        this.group_id = this.props.match.params.group_id;
        this.setState({
            loaded: false,
        })
        this.detail_recon.config({
          params:{
            group_id:this.group_id,
            recon_id:this.recon_id
          }
        }).execute()
        // fetch the new product based and set it to the state of the component
    };
};


}

export default withDomains(ReconcilerEdit,"settings");
